import { render, staticRenderFns } from "./AttributeEditor.vue?vue&type=template&id=49dc0461&"
import script from "./AttributeEditor.vue?vue&type=script&lang=ts&"
export * from "./AttributeEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports